var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.course.status_mode === _vm.statusModeButton)?_c('v-btn',{staticClass:"btn-basic uppercase",class:_vm.verifyLocked(),style:({
      backgroundColor: _vm.course.button_color + ' !important',
      color: _vm.course.button_text_color + ' !important'
    }),attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.goToMatricula()}}},[_vm._v(" "+_vm._s(_vm.course.button_text)+" ")]):_vm._e(),(_vm.course.status_mode === _vm.statusModeText)?_c('div',{class:_vm.typeStructure == 'desktop'
        ? 'left_content_passed'
        : 'left_content_passed2'},[_c('v-icon',{style:({
        color: _vm.course.text_icon_color
      }),attrs:{"large":""}},[_vm._v(_vm._s(_vm.course.text_icon))]),_c('div',{staticClass:"passed_text"},[_c('strong',{style:({
          color: _vm.course.text_color
        })},[_vm._v(" "+_vm._s(_vm.course.text_message)+" ")])])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }